module.exports = __webpack_public_path__ + "img/sd-ob1.4d15b9ef.svg";